import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
// import { PageEditComponent } from '../page-edit/page-edit.component';
// import { VideoEditComponent } from '../video-edit/video-edit/video-edit.component';
import { AuthService } from 'src/app/services/auth.service';
import { ApiService } from 'src/app/services/api/api.service';


@Component({
    selector: 'app-cms-strip',
    templateUrl: './cms-strip.component.html',
    styleUrls: ['./cms-strip.component.scss']
})
export class CmsStripComponent implements OnInit {

    constructor(
        public authService: AuthService,
        public apiService: ApiService,
        private _bottomSheet: MatBottomSheet
    ) { }

    ngOnInit(): void {
    }

    logout() {
        this.authService.logout()
    }

    addPage() {
        // this.pageService.makeNewPage()


        // const bottomSheetRef = this._bottomSheet.open(PageEditComponent, {
        //     ariaLabel: 'Edit Page'
        // });
    }

    addVideo() {
        // this.pageService.makeNewVideo()


        // const bottomSheetRef = this._bottomSheet.open(VideoEditComponent, {
        //     ariaLabel: 'Edit Video'
        // });
    }


}
